import React, { useEffect, useRef, useState } from "react";
import { useNavigate, useLocation } from "react-router-dom";
import Header from "../Header";
import { Footer } from "../Footer";

const NetworkCheck = () => {
  const navigate = useNavigate();
  const [isOnline, setIsOnline] = useState(navigator.onLine);

  // const checkNetworkStatus = () => {
  //   const onlineStatus = navigator.onLine;
  //   setIsOnline(onlineStatus);
  //   if (!onlineStatus) {
  //     navigate("/no-network");
  //   }
  // };

  const [count, setCount] = useState(0);

  useEffect(() => {
    const intervalId = setInterval(() => {
      const onlineStatus = navigator.onLine;
      setIsOnline(onlineStatus);
    }, 6000);

    return () => clearInterval(intervalId); // Cleanup interval on unmount
  }, []);

  const BackOnlinestyles = {
    heading: { color: "red", textAlign: "center" },
    text: { textAlign: "center", fontSize: "18px" },
  };
  console.log('isOnline',isOnline);
  
  const styles = {
    container: {
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      justifyContent: "center",
      height: "75vh",
      textAlign: "center",
      backgroundColor: "#f4f4f9",
      color: "#333",
      fontFamily: "Arial, sans-serif",
    },
    heading: {
      fontSize: "5rem",
      fontWeight: "bold",
      marginBottom: "1rem",
      color: "#ff6f61",
    },
    text: {
      fontSize: "1.5rem",
      marginBottom: "2rem",
    },
    link: {
      padding: "0.75rem 1.5rem",
      fontSize: "1rem",
      backgroundColor: "#007bff",
      color: "#fff",
      textDecoration: "none",
      borderRadius: "5px",
      transition: "background-color 0.3s",
    },
    linkHover: {
      backgroundColor: "#0056b3",
    },
  };
  return (
    // <div style={{ textAlign: 'center', marginTop: '50px' }}>
    //   <h1>404</h1>
    //   <p>Oops! The page you are looking for does not exist.</p>
    //   <Link to="/" style={{ color: 'blue', textDecoration: 'underline' }}>
    //     Go Back to Home
    //   </Link>
    // </div>/
    <>
      <Header />
      <div style={styles.container}>
        {!isOnline && (
          <>
            <h1 style={styles.heading}>📡 No Network Connection</h1>
            <p style={styles.text}>
              It seems like you're offline. Please check your internet
              connection and try again.
            </p>
          </>
        )}
        {isOnline && (
          <h1 style={{ ...styles.heading, color: "green" }}>✅ Back Online!</h1>
        )}
      </div>
      <Footer />
    </>
  );
};

export default NetworkCheck;
